import { PrepaySelectWidgetContent } from './PrepaySelectWidgetContent';
import { PrepaySelectWidgetCustomerContent } from './PrepaySelectWidgetCustomerContent';
import type { PrepaySelectWidgetProps } from './usePrepaySelectWidget';
import { WithStatusHandling } from '../WithStatusHandling';

export const PrepaySelectWidget = ({
  status,
  handlers,
  data,
  hooks,
  isCustomer,
  isStripe,
  isSingleBillChildAccount,
}: PrepaySelectWidgetProps) => {
  const ContentComponent = isCustomer && !isStripe ? PrepaySelectWidgetCustomerContent : PrepaySelectWidgetContent;

  return (
    <WithStatusHandling
      skeletonHeight={60}
      status={status}
      errorMessage={status === 'error' ? data.message : undefined}
      retry={status === 'error' ? handlers.retry : undefined}
    >
      {status === 'loaded' && (
        <ContentComponent
          data={data}
          handlers={handlers}
          hooks={hooks}
          isSingleBillChildAccount={isSingleBillChildAccount}
        />
      )}
    </WithStatusHandling>
  );
};
